const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

// Yeni eklenen fonksiyon: Web Vitals metriklerini console'a yazdırma
export const logWebVitalsToConsole = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(({ value }) => console.log('CLS:', value));
      getFID(({ value }) => console.log('FID:', value));
      getFCP(({ value }) => console.log('FCP:', value));
      getLCP(({ value }) => console.log('LCP:', value));
      getTTFB(({ value }) => console.log('TTFB:', value));
    });
  }
};

// Yeni eklenen fonksiyon: Web Vitals metriklerini bir API'ye gönderme
export const sendWebVitalsToAPI = onPerfEntry => {
  // if (onPerfEntry && onPerfEntry instanceof Function) {
  //   import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
  //     getCLS(({ value, id }) => {
  //       // navigator.sendBeacon('/api/web-vitals', JSON.stringify({ 
  //       //   name: metric.name,
  //       //   value: metric.value,
  //       //   id: metric.id,
  //       //   pathname: window.location.pathname,
  //       //   timestamp: new Date().toISOString()
  //       // }));
  //     });
      
  //     getFID(({ value, id }) => {
  //       navigator.sendBeacon('/api/web-vitals', JSON.stringify({ 
  //         metric: 'FID', 
  //         value, 
  //         id,
  //         url: window.location.href,
  //         timestamp: new Date().toISOString()
  //       }));
  //     });
      
  //     getFCP(({ value, id }) => {
  //       navigator.sendBeacon('/api/web-vitals', JSON.stringify({ 
  //         metric: 'FCP', 
  //         value, 
  //         id,
  //         url: window.location.href,
  //         timestamp: new Date().toISOString()
  //       }));
  //     });
      
  //     getLCP(({ value, id }) => {
  //       navigator.sendBeacon('/api/web-vitals', JSON.stringify({ 
  //         metric: 'LCP', 
  //         value, 
  //         id,
  //         url: window.location.href,
  //         timestamp: new Date().toISOString()
  //       }));
  //     });
      
  //     getTTFB(({ value, id }) => {
  //       navigator.sendBeacon('/api/web-vitals', JSON.stringify({ 
  //         metric: 'TTFB', 
  //         value, 
  //         id,
  //         url: window.location.href,
  //         timestamp: new Date().toISOString()
  //       }));
  //     });
  //   });
  // }
};

export default reportWebVitals;